(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.topHeader = this.querySelector('.new-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.onResizeHandler = this.setHeaderHeight.bind(this);
      this.headerMediaQuery = window.matchMedia('(max-width: 990px)');

      this.setHeaderHeight();
      requestAnimationFrame(this.onResizeHandler);

      this.headerMediaQuery.addEventListener('change', this.onResizeHandler);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.scrollTicking = false;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.predictiveSearchInput = this.predictiveSearch?.querySelector('input[type="search"]');
      this.closeBottomMenusForSearch = this.closeBottomMenusForSearch.bind(this);

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      window.addEventListener('resize', this.onResizeHandler);
      window.addEventListener('load', this.onResizeHandler);
      this.predictiveSearchInput?.addEventListener('focus', this.closeBottomMenusForSearch);
      this.predictiveSearchInput?.addEventListener('input', this.closeBottomMenusForSearch);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);

      if (this.topHeader) {
        document.documentElement.style.setProperty('--new-top-header-height', `${this.topHeader.offsetHeight}px`);
      }
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.onResizeHandler);
      window.removeEventListener('load', this.onResizeHandler);
      this.headerMediaQuery.removeEventListener('change', this.onResizeHandler);
      this.predictiveSearchInput?.removeEventListener('focus', this.closeBottomMenusForSearch);
      this.predictiveSearchInput?.removeEventListener('input', this.closeBottomMenusForSearch);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      if (this.scrollTicking) return;

      this.scrollTicking = true;
      requestAnimationFrame(() => {
        this.updateHeaderOnScroll();
        this.scrollTicking = false;
      });
    }

    updateHeaderOnScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) {
        this.hideTopHeader();
        return;
      }
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) {
        this.showTopHeader();
        return;
      }
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) {
        this.showTopHeader();
        return;
      }
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    hideTopHeader() {
      if (!this.topHeader || this.header.classList.contains('menu-open')) return;

      this.header.classList.add('new-header-top-hidden', 'animate');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    showTopHeader() {
      if (!this.topHeader) return;

      this.header.classList.add('animate');
      this.header.classList.remove('new-header-top-hidden');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }

    closeBottomMenusForSearch() {
      this.querySelector('bottom-header-nav')?.closeOpenMenus();
    }
  }

  customElements.define('sticky-header', StickyHeader);

  class BottomHeaderNav extends HTMLElement {
    connectedCallback() {
      this.scroller = this.querySelector('[data-bottom-nav-scroller]');
      this.leftArrow = this.querySelector('[data-bottom-nav-arrow="left"]');
      this.rightArrow = this.querySelector('[data-bottom-nav-arrow="right"]');
      this.overlay = this.closest('sticky-header')?.querySelector('[data-bottom-nav-overlay]');

      if (!this.scroller || !this.leftArrow || !this.rightArrow) return;

      this.updateArrows = this.updateArrows.bind(this);
      this.scrollLeft = this.scrollLeft.bind(this);
      this.scrollRight = this.scrollRight.bind(this);
      this.updateMenuPositions = this.updateMenuPositions.bind(this);
      this.scheduleMenuPositionUpdate = this.scheduleMenuPositionUpdate.bind(this);
      this.updateMenuState = this.updateMenuState.bind(this);
      this.closeOpenMenus = this.closeOpenMenus.bind(this);
      this.menuDetails = Array.from(this.querySelectorAll('details'));

      this.scroller.addEventListener('scroll', this.updateArrows, { passive: true });
      this.leftArrow.addEventListener('click', this.scrollLeft);
      this.rightArrow.addEventListener('click', this.scrollRight);
      this.overlay?.addEventListener('click', this.closeOpenMenus);
      window.addEventListener('resize', this.updateArrows);
      window.addEventListener('resize', this.updateMenuPositions);
      window.addEventListener('scroll', this.scheduleMenuPositionUpdate, { passive: true });
      this.menuDetails.forEach((details) => details.addEventListener('toggle', this.updateMenuState));
      this.enableDesktopHoverMenus();

      requestAnimationFrame(this.updateArrows);
      requestAnimationFrame(this.updateMenuState);
    }

    disconnectedCallback() {
      if (!this.scroller) return;

      this.scroller.removeEventListener('scroll', this.updateArrows);
      this.leftArrow.removeEventListener('click', this.scrollLeft);
      this.rightArrow.removeEventListener('click', this.scrollRight);
      this.overlay?.removeEventListener('click', this.closeOpenMenus);
      window.removeEventListener('resize', this.updateArrows);
      window.removeEventListener('resize', this.updateMenuPositions);
      window.removeEventListener('scroll', this.scheduleMenuPositionUpdate);
      this.menuDetails.forEach((details) => details.removeEventListener('toggle', this.updateMenuState));

      if (this.hoverMenuHandlers) {
        this.hoverMenuHandlers.forEach(({ menu, panel, open, scheduleClose, cancelClose }) => {
          menu.removeEventListener('mouseenter', open);
          menu.removeEventListener('mouseleave', scheduleClose);
          panel?.removeEventListener('mouseenter', cancelClose);
          panel?.removeEventListener('mouseleave', scheduleClose);
        });
      }
    }

    updateArrows() {
      const maxScroll = this.scroller.scrollWidth - this.scroller.clientWidth;
      const currentScroll = this.scroller.scrollLeft;
      const atStart = currentScroll <= 1;
      const atEnd = currentScroll >= maxScroll - 1;

      this.leftArrow.hidden = atStart;
      this.rightArrow.hidden = maxScroll <= 1 || atEnd;
    }

    scrollLeft() {
      this.scroller.scrollBy({ left: -this.scroller.clientWidth * 0.8, behavior: 'smooth' });
    }

    scrollRight() {
      this.scroller.scrollBy({ left: this.scroller.clientWidth * 0.8, behavior: 'smooth' });
    }

    updateMenuState() {
      this.updateMenuPositions();

      if (!this.overlay) {
        this.overlay = this.closest('sticky-header')?.querySelector('[data-bottom-nav-overlay]');
        this.overlay?.addEventListener('click', this.closeOpenMenus);
      }

      const hasOpenMenu = this.menuDetails.some((details) => details.open);
      this.overlay?.classList.toggle('is-visible', hasOpenMenu);
      this.overlay?.setAttribute('aria-hidden', String(!hasOpenMenu));
    }

    closeOpenMenus() {
      this.menuDetails.forEach((details) => {
        details.removeAttribute('open');
        details.querySelector('summary')?.setAttribute('aria-expanded', 'false');
      });
    }

    scheduleMenuPositionUpdate() {
      if (this.menuPositionTicking) return;

      this.menuPositionTicking = true;
      requestAnimationFrame(() => {
        this.updateMenuPositions();
        this.menuPositionTicking = false;
      });
    }

    updateMenuPositions() {
      const navRect = this.getBoundingClientRect();
      const menuTop = `${Math.round(navRect.bottom)}px`;
      this.style.setProperty('--bottom-menu-top', menuTop);
      this.overlay?.style.setProperty('--bottom-menu-top', menuTop);

      this.querySelectorAll('.new-bottom-header-dropdown[open]').forEach((details) => {
        const summaryRect = details.querySelector('summary')?.getBoundingClientRect();
        const panel = details.querySelector('.new-bottom-header-dropdown__menu');
        if (!summaryRect) return;

        const panelWidth = panel?.offsetWidth || 260;
        const maxLeft = window.innerWidth - panelWidth - 12;
        const left = Math.max(12, Math.min(Math.round(summaryRect.left), maxLeft));
        details.style.setProperty('--bottom-menu-left', `${left}px`);
      });
    }

    enableDesktopHoverMenus() {
      if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

      this.hoverMenuHandlers = Array.from(this.querySelectorAll('header-menu')).map((menu) => {
        const details = menu.querySelector('details');
        const summary = menu.querySelector('summary');
        const panel = details.querySelector('.new-bottom-header-dropdown__menu, .new-bottom-header-mega__content');
        let closeTimer;

        const open = () => {
          const predictiveSearch = this.closest('sticky-header')?.querySelector('.new-header__predictive-search');
          if (predictiveSearch?.matches('[open], [loading]') || predictiveSearch?.contains(document.activeElement)) {
            return;
          }

          window.clearTimeout(closeTimer);
          this.querySelectorAll('header-menu details[open]').forEach((openDetails) => {
            if (openDetails !== details) openDetails.removeAttribute('open');
          });
          details.setAttribute('open', '');
          summary.setAttribute('aria-expanded', 'true');
          this.updateMenuPositions();
        };
        const cancelClose = () => {
          window.clearTimeout(closeTimer);
        };
        const close = () => {
          details.removeAttribute('open');
          summary.setAttribute('aria-expanded', 'false');
        };
        const scheduleClose = () => {
          window.clearTimeout(closeTimer);
          closeTimer = window.setTimeout(close, 180);
        };

        menu.addEventListener('mouseenter', open);
        menu.addEventListener('mouseleave', scheduleClose);
        panel?.addEventListener('mouseenter', cancelClose);
        panel?.addEventListener('mouseleave', scheduleClose);

        return { menu, panel, open, scheduleClose, cancelClose };
      });
    }
  }

  customElements.define('bottom-header-nav', BottomHeaderNav);

  } catch(e) { console.error(e); }
})();
})();
